import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EncryptionService } from './encryption.service';
import { AppEnum } from '../appenum';
import * as CryptoJS from 'crypto-js';
import { AppService } from './app.service';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
import { LoggingService } from './logging.service';
@Injectable({
  providedIn: 'root'
})
export class CustomTranslateService implements TranslateLoader {
  public apiUrl = `${environment.apiUrl}`;
  private _appService!: AppService;
  secretKeyForDataEnc = "xT46emMu7wJpsQGe";  //key used in Python
  secretIVKeyForDataEnc = "U3U9lKwOGNTk0Rz8";
  orgId: any;
  componentName: string = 'custom-translate Service';
  constructor(private http: HttpClient, public encryptionService: EncryptionService, public _appenum: AppEnum,
    // public _appServices: AppService
    private injector: Injector
  ) {
    wrapAllMethodsWithLogging(this, this.componentName, this.injector, LoggingService);
  }

  private get appService(): AppService {
    if (!this._appService) {
      this._appService = this.injector.get(AppService);
    }
    return this._appService;
  }
  initLangSubscription(): void {
    const langLoading$ = this.appService?.isLangDataLoading;
    if (!langLoading$) {
      console.warn('isLangDataLoading is not initialized');
      return;
    }

    langLoading$.subscribe((res: boolean) => {
      if (!res) return;
      console.log("res", res)
      const orgId = this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(
          this._appenum.EntityOfLocalStorageKeys.orgId
        )
      );

      const lang = this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(
          this._appenum.EntityOfLocalStorageKeys.siteLocale
        )
      );
      if (orgId && lang) {
        this.getTranslation(lang).subscribe();
      }
    });
  }

  getTranslation(lang: string): Observable<any> {
    try {
      // Get and decrypt orgId
      const orgId = this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId)
      );
      // Validate orgId and lang
      if (!orgId || !lang) {
        console.warn('OrgId or language is invalid:', { orgId, lang });
        return of(null); // Return empty observable if invalid
      }

      const postJson = {
        orgId,
        languageCode: lang
      };
      const encryptedPayload = { data: this.encryptDataValues(JSON.stringify(postJson)) };

      return this.http.post(this.apiUrl + `v2/getLangData`, encryptedPayload).pipe(
        map((results: any) => {
          const jsonData: any = this.decryptDataValues(results?.data);
          return jsonData?.Data?.[0]?.languageJson || null;
        }),
        catchError(err => {
          const paramRequest = {
            httpRequest: {
              method: 'post',
              url: 'v2/getLangData',
              payLoad: postJson,
              response: { result: err }
            },
            taskDetails: ''
          };
          // this._appServices.logsActivity(
          //   this._appenum.EntityOfLogLevel.Error,
          //   'getLangData Error Case Self App',
          //   'Custom-translate-service',
          //   paramRequest.httpRequest,
          //   paramRequest.taskDetails
          // );
          return of(null); // Emit null on error
        })
      );

    } catch (error) {
      return of(null);
    }
  }


  encryptDataValues(data) {
    var key = CryptoJS.enc.Utf8.parse(this.secretKeyForDataEnc);
    var iv = CryptoJS.enc.Utf8.parse(this.secretIVKeyForDataEnc)
    var encrypted: any = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC });
    encrypted = encrypted.toString();
    return encrypted.toString();
  }

  decryptDataValues(Base64CBC) {
    var iv = CryptoJS.enc.Utf8.parse(this.secretIVKeyForDataEnc);
    var key = CryptoJS.enc.Utf8.parse(this.secretKeyForDataEnc);
    var decrypted: any = CryptoJS.AES.decrypt(Base64CBC, key, { iv: iv, mode: CryptoJS.mode.CBC });
    decrypted = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  }
}
